import { defineComponent as _defineComponent } from 'vue'
import {
  computed, onMounted, PropType, ref, toRefs, watch
} from 'vue';
import { BcxFormField, BcxFormFieldErrorMessage } from '@/models/BcxForm';
import {
  templateRef, useDebounceFn, useEventListener, useVModel
} from '@vueuse/core';
import BCXFormField from '@/components/molecules/forms/BCXFormField.vue';
import BCXFormFieldError from '@/components/molecules/forms/BCXFormFieldError.vue';
import animationFrameWait from '@/utils/animationFrameWait';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXForm',
  props: {
  fields: {
    type: Array as PropType<Array<BcxFormField | null>>,
    default: () => []
  },
  data: {
    type: Object as PropType<Record<string, string>>,
    default: () => ({})
  },
  horizontalGap: {
    type: String,
    default: '16px'
  },
  verticalGap: {
    type: String,
    default: '16px'
  },
  errorMessages: {
    type: Object as PropType<Record<string, BcxFormFieldErrorMessage>>,
    default: () => ({})
  },
  errorDisplayMode: {
    type: String as PropType<'line' | 'block'>,
    default: 'line'
  },
},
  emits: ['update:data', 'blur'],
  setup(__props, { emit }) {

const props = __props;



const {
  errorMessages, fields, data,
} = toRefs(props);

const formFieldRef = templateRef('formfield');
const isGroupScanning = ref(false);


const vmData = useVModel(props, 'data', emit);

const lineGroups = ref<Record<string, BcxFormField[]>>({});

const updateField = (name: string, value: string) => {
  vmData.value = {
    ...vmData.value,
    [name]: value
  };
};

const onBlur = (field: BcxFormField) => {
  emit('blur', field);
};

const lineGroupErrorMessages = computed(() => Object.fromEntries(
  Object.entries(lineGroups.value).map(([name, fields]) => {
    const messages = fields
      .filter((field) => {
        const errorMessage = errorMessages?.value?.[field.name];
        return errorMessage?.isVisible && !!errorMessage?.message;
      })
      .map((field) => ({ label: field.label, message: errorMessages.value[field.name].message }));
    return {
      name,
      messages
    };
  }).filter(({ messages }) => messages?.length).map(({ name, messages }) => [name, messages])
));

const getBreaks = async () => {
  isGroupScanning.value = true;
  await animationFrameWait(2);
  const groups:Record<string, BcxFormField[]> = {};

  if (props.errorDisplayMode === 'block') {
    lineGroups.value = { [props.fields.at(-1).name]: props.fields };
    return;
  }

  let group:BcxFormField[] = [];
  let lastY: null | number = null;

  formFieldRef.value?.forEach((field, idx) => {
    const { $el } = field;
    const { top } = $el.getBoundingClientRect();
    if (lastY === null) lastY = top;

    if (top > lastY + 20) {
      groups[group.at(-1).name] = group;
      group = [];
    }

    group.push(props.fields[idx]);

    lastY = top;
  });

  if (group.length) {
    groups[group.at(-1).name] = group;
  }

  lineGroups.value = groups;
  isGroupScanning.value = false;
};

// re-check field if some of it's definition changes
watch(fields, () => {
  getBreaks();
});

onMounted(() => getBreaks());
useEventListener(window, 'resize', useDebounceFn(getBreaks, 250));


return { __sfc: true,props, errorMessages, fields, data, formFieldRef, isGroupScanning, emit, vmData, lineGroups, updateField, onBlur, lineGroupErrorMessages, getBreaks, BCXFormField, BCXFormFieldError }
}

})